'use es6';

/* Libs  */
import { BrowserRouter, Route } from 'quartz-routing/react-router';
import { RhumbProvider } from 'react-rhumb';
import { ThemeProvider } from 'styled-components';
import { renderRoot } from 'quartz-core/client';
import { Suspense } from 'react';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import setDocumentTitle from 'I18n/utils/setDocumentTitle';
import Routes from './Routes';
import rhumbConfig from '../rhumb-config.yaml';
import theme from './theme';

/* Components  */
import { loadI18n } from './utils/I18n';
import ErrorBoundary from './components/ErrorBoundary';
import GlobalStyles from './components/ui/styles/GlobalStyles';
import LocaleProvider from './components/ui/misc/LocaleProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class Application {
  start() {
    // This particular invalid product hit drops our SLA significantly
    if (window.location.search.indexOf('product=fzbvyFgbegfe') !== -1) {
      document.write('Invalid product provided');
      return;
    }
    loadI18n().then(() => {
      setDocumentTitle('app.htmlTitle');
      this.startRouter();
    }).catch(() => {
      //Todo: Send this error to error log https://git.hubteam.com/HubSpot/subscriptions/issues/2670
    });
  }
  startRouter() {
    renderRoot( /*#__PURE__*/_jsx(ThemeProvider, {
      theme: theme,
      children: /*#__PURE__*/_jsx(LocaleProvider, {
        children: /*#__PURE__*/_jsx(Suspense, {
          fallback: /*#__PURE__*/_jsx("div", {}),
          children: /*#__PURE__*/_jsx(BrowserRouter, {
            basename: "/email-unsubscribe",
            children: /*#__PURE__*/_jsx(Route, {
              children: ({
                history
              }) => /*#__PURE__*/_jsx(RhumbProvider, {
                config: rhumbConfig,
                history: historyAdapter(history),
                children: /*#__PURE__*/_jsxs(ErrorBoundary, {
                  children: [/*#__PURE__*/_jsx(Routes, {}), /*#__PURE__*/_jsx(GlobalStyles, {})]
                })
              })
            })
          })
        })
      })
    }));
  }
}